/**
 * Formats manufacturer names by removing hyphens and capitalizing properly
 * This ensures consistent display of manufacturer names across the application
 */
export const formatManufacturerName = (
  manufacturerName: string | undefined | null
): string => {
  if (!manufacturerName) return "";

  return manufacturerName
    .replace(/-/g, " ")
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

